import React, { Component } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import "./AutomationDetail.scss";
import UIService from "../../../../../services/UIService";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import IAutomation from "../../../../../models/IAutomation";
import IGetAutomationsDTO from "../../../../../models/DTO/IGetAutomationsDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import IOnGetAutomationsDTO from "../../../../../models/DTO/IOnGetAutomationsDTO";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notify: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    automations: IAutomation[];
    updateAutomationsFn: (automation: IAutomation) => void;
    deleteAutomationsFn: (automation: IAutomation, index: number) => void;
};

type State = {
    typeaheadItems: IAutomation[];
    selectedAutomation?: IAutomation;
    automations: IAutomation[];
    clearTypeahead: boolean;
};

class AutomationDetail extends Component<Props, State> {
    readonly state: State = {
        typeaheadItems: [],
        automations: this.props.automations,
        clearTypeahead: false,
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.AutomationOnGetAutomations, this.onGetAutomations);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.AutomationOnGetAutomations, this.onGetAutomations);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.automations.length !== this.props.automations.length) {
            this.setState({
                automations: this.props.automations,
            });
        }
    }

    getAutomations = (name: string) => {
        const payload: IGetAutomationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.AutomationGetAutomations, payload);
    };

    onGetAutomations = (data: IOnGetAutomationsDTO) => {
        this.setState({
            typeaheadItems: data.automations,
        });
    };

    selectedItem = (automation: IAutomation) => {
        this.setState({
            selectedAutomation: automation,
        });
    };

    addSelectedItem = () => {
        if (this.state.selectedAutomation) {
            const automations = this.state.automations;

            automations.push(this.state.selectedAutomation);

            const newAutomation = this.state.selectedAutomation;

            this.setState(
                {
                    automations,
                    selectedAutomation: undefined,
                    clearTypeahead: true,
                },
                () => {
                    this.props.updateAutomationsFn(newAutomation);
                }
            );
        }
    };

    clearTypeahead = () => {
        this.setState({
            selectedAutomation: undefined,
            clearTypeahead: false,
        });
    };

    deleteAutomation = (automation: IAutomation, index: number) => {
        const automations = this.state.automations;

        automations.splice(index, 1);

        this.setState(
            {
                automations,
            },
            () => {
                this.props.deleteAutomationsFn(automation, index);
            }
        );
    };

    render() {
        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        return (
            <div className="AutomationsDetail mt-2">
                <div>
                    <OwLabel title={"automations"} />
                </div>

                <div className={"d-flex flex-row"}>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getAutomations}
                        typeaheadItems={this.state.typeaheadItems}
                        titleProp={"name"}
                        selectedItemFn={this.selectedItem}
                        selectedItemTitleProp={"name"}
                        clearTypeaheadCallback={this.clearTypeahead}
                        clearTypeahead={this.state.clearTypeahead}
                    />

                    <div>
                        <OwButton title={"add"} fn={this.addSelectedItem} />
                    </div>
                </div>

                <div>
                    <table className={`table table-borderless ${tableClass}`}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <OwLabel title={"name"} noBottomMargin={true} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.automations.map((automation, index: number) => {
                                return (
                                    <tr key={automation.guid}>
                                        <td>
                                            {
                                                <i
                                                    className={"fas fa-trash-alt text-danger pointer"}
                                                    onClick={() => {
                                                        this.deleteAutomation(automation, index);
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td>{automation.name}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default AutomationDetail;
